module.exports = __webpack_public_path__ + "static/media/progman_31.5c685ffa.ico";